var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {
    staticClass: "pix-blurred-field blurred",
    domProps: {
      textContent: _vm._s(_vm.genericFunctionsUtils.getRandomFieldValue()),
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }